module.exports = __webpack_public_path__ + "static/media/05.cd65b122.jpg";